<template lang="pug">
	.timeline
		ul
			li.message.preview(
				v-if="preview"
			)
				timeline-message(
					:main-club="mainClub"
					:headline="preview.headline"
					:message="preview.message"
					:media="preview.media"
					:players="preview.players"
					:action="preview.action"
					:transition-action="preview.transitionAction"
					:club="preview.club"
					:is-editing="false"
					:public="preview.public"
					:time="preview.time"
					:main-team-crest="mainTeamCrest"
					:opponent-team-crest="opponentTeamCrest"

					preview
				)
				label.preview-label(v-if="preview && !preview._id") Vorschau der neuen Nachricht:
				label.preview-label(v-if="preview && preview._id") Vorschau der bearbeiteten Nachricht:

			draggable(
				handle=".draggable-handle"
				v-model="orderedMessages"
				group="timeline"
				:disabled="!editable"
				@start="onDragStart"
				@end="onDragEnd"
			)
				transition-group(
					:name="isTransitionEnabled ? 'timeline' : null"
				)
					li.message(
							v-for="message in orderedMessages"
							:key="message._id"
					)
						timeline-message(
							:main-club="mainClub"
							:goal-sponsor="goalSponsor"
							:goal-sponsor-link="goalSponsorLink"

							:id="message._id"
							:public="message.public"
							:headline="message.headline"
							:message="message.message"
							:time="message.time"
							:media="message.media"
							:players="message.players"
							:action="message.action"
							:transition-action="message.transitionAction"
							:club="message.club"
							:main-team-crest="mainTeamCrest"
							:opponent-team-crest="opponentTeamCrest"
							:editable="editable",
							@delete="$emit('delete', message)"
							@edit="$emit('edit', message)"
							@toggle="$emit('toggle', message)"
						)
</template>
<script>
import TimelineMessage from './TimelineMessage'
import draggable from 'vuedraggable'
import { setTimeout } from 'timers'

export default {
	components: {
		TimelineMessage,
		draggable
	},
	props: {
		mainClub: {
			type: String,
			default: ''
		},
		editable: {
			type: Boolean,
			default: false
		},
		messages: {
			type: Array,
			required: true
		},
		order: {
			type: Array,
			required: true
		},
		preview: {
			type: Object,
			default: null
		},
		goalSponsor: Object,
		goalSponsorLink: String,
		mainTeamCrest: String,
		opponentTeamCrest: String
	},
	data () {
		return {
			isDragging: false,
			isTransitionEnabled: true,
			sortableOptions: {
				group: 'messages'
			}
		}
	},
	computed: {
		orderedMessages: {
			get () {
				return [...this.order].reverse()
					.map(id => this.messages.find(m => m._id === id))
					.filter(m => m !== undefined)
			},
			set (v) {
				var reorderedIds = v.map(m => m._id)
				this.$emit('update:order', reorderedIds)
			}
		}
	},
	methods: {
		onDragStart () {
			this.isDragging = true
			this.isTransitionEnabled = false
		},
		onDragEnd () {
			this.isDragging = false
			setTimeout(() => {
				if (!this.isDragging) {
					this.isTransitionEnabled = true
				}
			}, 100)
		}
	}
}
</script>

<style lang="scss" scoped>
	@import '../style/variables.scss';
	@import '../style/fonts.scss';

	.timeline {
		font-family: 'Bunday Sans', sans-serif;
		ul {
			position: relative;
			display: block;
			list-style: none;
			margin: 0;

			li.message {
				position: relative;
				margin-bottom: 1em;
				transition: all 0.5s;

				&.preview {
					label {
						color: $primary;
						font-size: 0.8em;
						font-weight: 600;
						position: absolute;
						top: -1.5em;
						left: 0;
					}
				}
			}

			&:before {
				content: '';
				position: absolute;
				left: 12%;
				margin-left: -0.5px;
				width: 1px;
				top: 30px;
				bottom: 0.5em;
				background: $timeline;
				z-index: 1;

			}

			@media screen and (max-width: 768px) {
				&:before {
					left: 20px;
				}
			}
		}
	}

.timeline-enter-active,
.timeline-leave-active,
.timeline-move {
  transition: 500ms cubic-bezier(0.59, 0.12, 0.34, 0.95);
  transition-property: opacity, transform;
}

.timeline-enter {
  opacity: 0;
  transform: translateX(50px) scaleY(0.5);
}

.timeline-enter-to {
  opacity: 1;
  transform: translateX(0) scaleY(1);
}

.timeline-leave-active {
  position: absolute;
}

.timeline-leave-to {
  opacity: 0;
  transform: scaleY(0);
  transform-origin: center top;
}

.list-move {
  transition: transform 0.5s;
}
</style>
